import debug from 'debug';
import {
    top
} from './const';

/**
 * 是否为顶级窗口
 */
export const isTop = () => window === top;

/**
 * 向顶级窗口发送信息
 *  通用方法, 没有经过 SMP 处理, 用于 souche-menu-dashboard 或 rollback
 * @param {*} res
 */
export const send = (res:any) => top.postMessage(res, '*');

/**
 * debug 日志
 */
export const log = debug('SMP');
export const logMR = debug('SMP:MR');
export const logPR = debug('SMP:PR');
export const logMSG = debug(`SMP:MSG:${isTop() ? '#top' : window.name}`);
